import {
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { DAYS_OF_THE_WEEK } from "contexts/NewCampaign";
import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { useContext } from "react";
import { Campaign } from "schemas/dashboard";

import { convertTo12HourFormat, formatCampaignDate } from "utils/time";

interface Props {
  campaign: Campaign | null;
  partialCampaign?: Campaign;
}

const UneditableCampaignDetails = ({ partialCampaign, campaign }: Props) => {
  const { templates: allTemplates } = useContext(OutreachTemplatesContext);

  const templates = campaign?.emailSetting?.emailSettingTemplates?.map(
    (emailSettingTemplate) =>
      allTemplates.find((t) => t.id === emailSettingTemplate.templateId),
  );
  const selectedFollowups = templates?.slice(1, templates?.length);

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" sx={{ fontSize: 15, color: grey[700] }}>
          Campaign Details
        </Typography>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography>Outreach Template</Typography>
      </Grid>
      <Grid item xs={6} sm={8}>
        {templates && templates[0]?.name}
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography>Campaign Dates</Typography>
      </Grid>
      <Grid item xs={6} sm={8}>
        <Grid container alignItems="center" spacing={1}>
          <Grid item>
            {formatCampaignDate(partialCampaign?.startDate)} to{" "}
            {formatCampaignDate(partialCampaign?.endDate)}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography>Sending Time</Typography>
      </Grid>
      <Grid item xs={6} sm={8}>
        <Grid container alignItems="center" xs={12} spacing={1}>
          <Grid item>
            {convertTo12HourFormat(partialCampaign?.startTime)} to{" "}
            {convertTo12HourFormat(partialCampaign?.endTime)} (
            {partialCampaign?.timezone})
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography>Days of the Week</Typography>
      </Grid>
      <Grid item xs={6} sm={8}>
        <ToggleButtonGroup value={partialCampaign?.daysOfWeek} size="small">
          {DAYS_OF_THE_WEEK.map((day) => (
            <ToggleButton key={day[0]} value={day[0]} disabled>
              {day[1]}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Grid>
      <Grid item xs={6} sm={4}>
        <Typography>Follow-up Templates</Typography>
      </Grid>
      <Grid item xs={6} sm={8}>
        {selectedFollowups?.map((followup, index) => (
          <Grid container sx={{ mb: 1 }} key={index}>
            <Grid container alignItems="center">
              {followup?.name}
            </Grid>
            <Grid container>
              <Typography
                variant="caption"
                sx={{ fontStyle: "italic", fontSize: 10 }}
                color="textSecondary"
              >
                Sent 4 business days after previous email
              </Typography>
            </Grid>
          </Grid>
        ))}
      </Grid>
    </>
  );
};

export default UneditableCampaignDetails;
